import { createElement } from 'react';
import DOMPurify from 'dompurify';
import { CONFIG } from './renderJiraHtml';

// Renders a snippet of Jira HTML as React elements instead of injecting a string with
// dangerouslySetInnerHTML. The HTML is sanitised with DOMPurify (same allow-list as
// renderJiraHtml), then walked node by node, so only allow-listed tags and the `href` /
// `title` attributes can ever reach the DOM, and text is always inserted as text.

const VOID_TAGS = new Set(['br', 'hr']);

function toReact(node, key) {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent;
  if (node.nodeType !== Node.ELEMENT_NODE) return null;

  const tag = node.tagName.toLowerCase();
  const props = { key };
  const title = node.getAttribute('title');
  if (title) props.title = title;
  if (tag === 'a') {
    const href = node.getAttribute('href');
    if (href) props.href = href;
    props.target = '_blank';
    props.rel = 'noopener noreferrer';
  }

  if (VOID_TAGS.has(tag)) return createElement(tag, props);
  const children = Array.from(node.childNodes).map((child, i) => toReact(child, i));
  return createElement(tag, props, ...children);
}

export function jiraHtmlToReact(html) {
  if (html == null || html === '') return null;
  const fragment = DOMPurify.sanitize(String(html), { ...CONFIG, RETURN_DOM_FRAGMENT: true });
  const nodes = Array.from(fragment.childNodes).map((node, i) => toReact(node, i));
  return nodes.length ? nodes : null;
}
